/**
 * "az önce", "12 dk önce", "3 saat önce", "dün 14:32", "5 gün önce",
 * daha eskisi tarih. Sistem panelinde son görülme için.
 */
export function ago(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return 'hiç'
  const t = Date.parse(iso)
  if (!Number.isFinite(t)) return 'hiç'
  const min = Math.floor((now - t) / 60000)
  if (min < 2) return 'az önce'
  if (min < 60) return `${min} dk önce`
  const h = Math.floor(min / 60)
  const d = new Date(t)
  const clock = d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })
  const today = new Date(now)
  const yesterday = new Date(now - 86400000)
  if (d.toDateString() === today.toDateString()) return h < 6 ? `${h} saat önce` : `bugün ${clock}`
  if (d.toDateString() === yesterday.toDateString()) return `dün ${clock}`
  const days = Math.floor(min / 1440)
  if (days < 7) return `${days} gün önce`
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

/** Nokta rengi: son 24 saat taze, son 7 gün ılık, daha eskisi soğuk. */
export function freshness(iso: string | null | undefined, now = Date.now()): 'fresh' | 'warm' | 'cold' {
  if (!iso) return 'cold'
  const h = (now - Date.parse(iso)) / 3600000
  return h < 24 ? 'fresh' : h < 24 * 7 ? 'warm' : 'cold'
}

/** İki zamandan yenisi (son görülme ile şifreyle giriş). */
export const latest = (...isos: (string | null | undefined)[]) =>
  isos.filter((x): x is string => !!x).sort((a, b) => Date.parse(b) - Date.parse(a))[0] ?? null
